import { cn } from '../../lib/cn';

export interface ProgressBarProps {
  value: number; // 0..100
  className?: string;
  ariaLabel?: string;
}

export function ProgressBar({ value, className, ariaLabel }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={cn('h-1.5 w-full rounded-full bg-tg-section-bg overflow-hidden', className)}
    >
      <div
        className="h-full bg-brand transition-[width] duration-300 ease-smooth"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
